import { type FormEvent, useState } from 'react';
import { Modal } from './Modal';

export function TopUpModal({ maxAmount, onSubmit, onClose }: { maxAmount: number; onSubmit: (amount: number) => void; onClose: () => void }) {
  const [text, setText] = useState('');
  const [error, setError] = useState<string | null>(null);
  function submit(e: FormEvent): void {
    e.preventDefault();
    const amount = Number(text);
    if (!Number.isInteger(amount) || amount < 1 || amount > maxAmount) { setError(`Amount must be between 1 and ${maxAmount}`); return; }
    onSubmit(amount);
  }
  return (
    <Modal title="Top up" onClose={onClose}>
      <form onSubmit={submit} noValidate>
        <label>Amount<input type="number" inputMode="numeric" min={1} max={maxAmount} value={text} onChange={e => setText(e.target.value)} autoFocus /></label>
        <p className="muted">The host approves top-ups; chips are added between hands.</p>
        {error && <p className="error" role="alert">{error}</p>}
        <div className="modal-actions"><button type="submit" className="btn green">REQUEST TOP UP</button></div>
      </form>
    </Modal>
  );
}
